module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Map/Marker2-45c7c8a8c10e47b85ddea49b1084af83.svg";